export default __webpack_public_path__ + "static/media/delftbanner.0524151b.jpg";